<div class="header">
    <i class="fa fa-times header-icon shadow-animation" aria-hidden="true"></i>
</div>
<h5 class="card-title text-danger">Pagamento rejeitado</h5>
<div class="d-grid gap-2 d-md-block">
    <button class="btn btn-danger" type="button" (click)="goToBooking()">Voltar a Reserva</button>
    <!-- <button class="btn btn-danger m-1" type="button" (click)="goToHome()">Cancelar</button> -->
</div>